export const CITY_NAME =
  import.meta.env.VITE_CITY_NAME || (typeof window !== 'undefined' && window.ENV?.CITY_NAME) || ''

const PAGES = {
  index: {
    title: `Home | ${CITY_NAME}`,
    description: `Home for ${CITY_NAME}`,
  },
  scheduling: {
    title: `Scheduling | ${CITY_NAME}`,
    description: `Scheduling for ${CITY_NAME}`,
  },
  changePassword: {
    title: `Change Password | ${CITY_NAME}`,
    description: `Change Password for ${CITY_NAME}`,
  },
  login: {
    title: `Login | ${CITY_NAME}`,
    description: `Login to CitySense for ${CITY_NAME}`,
  },
  drivers: {
    title: `Drivers | ${CITY_NAME}`,
    description: `Drivers for ${CITY_NAME}`,
  },
  vehicles: {
    title: `Vehicles | ${CITY_NAME}`,
    description: `Vehicles for ${CITY_NAME}`,
  },
  routes: {
    title: `Routes | ${CITY_NAME}`,
    description: `Routes for ${CITY_NAME}`,
  },
  driveStatistics: {
    title: `Drive Statistics | ${CITY_NAME}`,
    description: `Drive Statistics for ${CITY_NAME}`,
  },
  driveDetails: {
    title: `Drive Details | ${CITY_NAME}`,
    description: `Drive Details for ${CITY_NAME}`,
  },
  hotlineCalls: {
    title: `Hotline Calls | ${CITY_NAME}`,
    description: `Hotline Calls for ${CITY_NAME}`,
  },
  shifts: {
    title: `Shifts | ${CITY_NAME}`,
    description: `Shifts for ${CITY_NAME}`,
  },
  hardware: {
    title: `Hardware | ${CITY_NAME}`,
    description: `Hardware for ${CITY_NAME}`,
  },
  carNavigation: {
    title: `Car Navigation | ${CITY_NAME}`,
    description: `Car Navigation for ${CITY_NAME}`,
  },
  unexpectedEvents: {
    title: `Unexpected events | ${CITY_NAME}`,
    description: `Unexpected events for ${CITY_NAME}`,
  },
}

export default PAGES
